import './styles.scss';
import React from 'react';
import ProspectusLink from '@prospectus/common/ui-strict/ProspectusLink';
import { useIsShowing } from '@src/utils/cohesion/hooks/useIsShown';
import tagularEvent from '@src/utils/cohesion/helpers/TagularEvent';
import InnerBaseCard from './InnerBaseCard';

import { BaseCardProps } from './types';

function BaseCard({
  url,
  cardAnalytics,
  customHeaderImage,
  schoolLogo,
  title,
  titleTruncate = 3,
  subtitle,
  variant,
  productTypeCopy,
  footer,
  uuid,
  shouldfirePreQuerySegmentEvent,
  handleOnClick,
  isLoading = false,
  useCohesion,
  cohesionPayload,
}: BaseCardProps) {
  const ref = useIsShowing(() => {
    if (useCohesion) {
      const payload = cohesionPayload;
      payload.webContext.page.url = window.location.href;
      tagularEvent('ProductViewed', payload);
    }
  });

  return (
    <div ref={ref} className="base-card-wrapper">
      <ProspectusLink
        href={url}
        className="base-card-link"
        analytics={cardAnalytics}
      >
        <InnerBaseCard
          customHeaderImage={customHeaderImage}
          schoolLogo={schoolLogo}
          title={title}
          titleTruncate={titleTruncate}
          subtitle={subtitle}
          variant={variant}
          productTypeCopy={productTypeCopy}
          footer={footer}
          uuid={uuid}
          shouldfirePreQuerySegmentEvent={shouldfirePreQuerySegmentEvent}
          handleOnClick={handleOnClick}
          isLoading={isLoading}
        />
      </ProspectusLink>
    </div>
  );
}

export default BaseCard;
